// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.loadBar[data-v-1336748e] {
  --target-width: 0px;
  animation: load-1336748e forwards ease-out 1500ms;
}
.no-scrollbar[data-v-1336748e] {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
.no-scrollbar[data-v-1336748e]::-webkit-scrollbar {
  display: none;
}
@keyframes load-1336748e {
from {
    width: 0%;
}
to {
    width: var(--target-width);
}
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
